import { FC, PropsWithChildren, ReactPortal, useState } from 'react';

import ModalContext from './ModalContext';

const ModalContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [portal, setPortal] = useState<ReactPortal | null>(null);
  const [secondaryPortal, setSecondaryPortal] = useState<ReactPortal | null>(
    null
  );
  const [portalWrapper, setPortalWrapper] = useState<HTMLDivElement | null>(
    null
  );
  const [secondaryPortalWrapper, setSecondaryPortalWrapper] =
    useState<HTMLDivElement | null>(null);

  const { Provider } = ModalContext;

  return (
    <Provider
      value={{
        portal,
        secondaryPortal,
        setPortal,
        setSecondaryPortal,
        portalWrapper,
        secondaryPortalWrapper,
        setPortalWrapper,
        setSecondaryPortalWrapper,
      }}
    >
      {children}
      {portal}
      {secondaryPortal}
    </Provider>
  );
};

export default ModalContextProvider;
